function checkPhoneNumber(number) {
    // Define a regular expression to match various phone number formats
    const phoneRegex = /^(\+?\d{1,3}[\s.-]?)?(\(?\d{3}\)?|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/;

    // Test the input against the regex pattern
    return phoneRegex.test(number);
}

export { checkPhoneNumber };
